import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/lib/query-client'
import { applyDevAuthFromEnv, applyMockAuth, restoreCognitoSession } from '@/lib/auth'
import { isCognitoConfigured } from '@/lib/amplify'
import { setAccessToken } from '@/lib/api-client'
import '@/i18n'
import '@/styles/globals.css'
import { initTheme } from '@/store/theme'
import App from './App'

const useMocks = import.meta.env.VITE_USE_MOCKS === 'true'

initTheme()

async function bootstrap() {
  if (import.meta.env.DEV && useMocks) {
    const { worker } = await import('./mocks/browser')
    await worker.start({ onUnhandledRequest: 'bypass' })
    console.log('[MSW] Mock Service Worker started')
    applyMockAuth()
  } else if (import.meta.env.DEV) {
    applyDevAuthFromEnv()
  } else if (isCognitoConfigured()) {
    await restoreCognitoSession()
  } else {
    const stored = localStorage.getItem('accessToken')
    if (stored) {
      setAccessToken(stored)
    }
    const { useAuthStore } = await import('@/store/auth')
    useAuthStore.getState().setLoading(false)
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </BrowserRouter>
    </React.StrictMode>,
  )
}

void bootstrap()
